import { Injectable } from '@angular/core';
import { ModalService } from '@shopping-angular-components/modal';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { Messages, MessagesService } from 'projects/common/services/messages.service';
import { OfferCardData } from '../offer-card-data.model';
import { SelectableDatesComponent } from './selectable-dates.component';

@Injectable({
  providedIn: 'root'
})
export class SelectableDatesService {
  webview: boolean;
  messages: Messages;

  constructor(private modalService: ModalService, landingService: LandingModelService, messagesService: MessagesService) {
    const landing = landingService.getLandingModel();
    this.messages = messagesService.getMessages(landing.language, landing.country);
    this.webview = landing.webview;
  }

  openModal(currency: string, data: OfferCardData, moduleId: string, moduleIndex: number, uniqueId?: string) {
    this.modalService.showModal({
      id: 'selectable-dates',
      evaClasses: `-${data.offer_type.toLowerCase()}`,
      contentComponent: SelectableDatesComponent,
      contentModel: {
        moduleId,
        moduleIndex,
        uniqueId,
        offers: data.offer_alternatives,
        messages: this.messages,
        currency: currency,
        offerType: data.see_more_offers_link,
        viewMoreLink: data.link.url,
        product: data.product
      },
      product: 'nymeria',
      flow: 'landing',
      isWebview: this.webview
    })
  }
}
